import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { useFormikContext } from "formik";
import React from "react";

import MDTypography from "@/components/atoms/MDTypography";
import {
  HeaderTableCell,
  TableContainer,
  TableHeaderRow,
} from "@/components/molecules/Table/styled";
import { OrderFormData } from "@/components/screens/OrderFormPage/types";
import { PaymentDataTabMessages } from "@/messages/order-form-page/payment-data-tab.messages";

import { PaymentTableRow } from "./row";
import { PAYMENTS_TABLE_COLUMNS } from "../../../constants";

interface Props {
  messages: PaymentDataTabMessages;
  isTalk2BuyChannel: boolean;
}

export function PaymentsTable({ messages, isTalk2BuyChannel }: Props) {
  const columns = PAYMENTS_TABLE_COLUMNS(messages);
  const { values } = useFormikContext<OrderFormData>();
  const { payments } = values;

  return (
    <TableContainer sx={{ marginTop: 1 }}>
      <Table stickyHeader aria-label="sticky table">
        <TableHead>
          <TableHeaderRow>
            {columns.map((label, index) => (
              <HeaderTableCell key={`${index} - ${label}`}>{label}</HeaderTableCell>
            ))}
          </TableHeaderRow>
        </TableHead>

        <TableBody>
          {payments && payments.length === 0 ? (
            <TableRow>
              <TableCell colSpan={columns.length} align="center">
                <MDTypography variant="h6" color="text" fontWeight="regular">
                  {messages.noPaymentsMessage}
                </MDTypography>
              </TableCell>
            </TableRow>
          ) : (
            payments.map((singlePayment, index) => (
              <PaymentTableRow
                messages={messages}
                key={`${index} - ${singlePayment.id}`}
                payment={singlePayment}
                index={index}
                isTalk2BuyChannel={isTalk2BuyChannel}
              />
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
